import { HelmetDexteel } from "@dexteel/mesf-core";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { Cassette } from "../../models/Cassette";
import { getCassettes } from "../../repositories/CassetteRepository";
import { TableCassette } from "./components/TableCassette";

export const useCassettes = (
	partId?: number,
	onError?: (error: Error) => void,
) => {
	return useQuery<Cassette[], Error>({
		queryKey: ["cassettes", partId],
		meta: { realtime: ["M2.GetCassettes"] },
		queryFn: ({ signal }) => getCassettes({ partId }, signal),
		onError: onError,
	});
};

export const CassettePage = () => {
	const { partId } = useParams();

	return (
		<>
			<HelmetDexteel title="Cassettes" />
			<TableCassette partId={partId} />
		</>
	);
};
